<template>
    <vue-simplemde
        v-model="content"
        :configs="options"
        :name="name"
        ref="editor"
    />
</template>

<script>
    import VueSimplemde from 'vue-simplemde'
    // import markdownEditor from 'vue-simplemde/src/markdown-editor';

    export default {
        props: {
            name: String,
            viewer: Boolean,
            value: String,
        },

        data() {
            return {
                content: '',

                options: {
                    spellChecker: false,
                    status: false,
                    toolbar: [
                        'bold', 'italic', 'strikethrough', '|',
                        'heading', 'quote', 'code', 'image', '|',
                        'unordered-list', 'ordered-list', 'horizontal-rule', '|',
                        'fullscreen', 'preview'
                    ],
                    insertTexts: {
                        image: ["![](", ")"],
                    },
                }
            }
        },

        mounted() {
            // prefill
            this.content = this.value ? this.value : ''

            // paste image from media library
            this.$root.$on('paste-img', payload => {
                let simplemde = this.$refs.editor.simplemde
                let pos = simplemde.codemirror.getCursor();
                let text = payload.isImage ? `![](${payload.mediaUrl})` : `[${payload.name}](${payload.mediaUrl})`

                simplemde.codemirror.setSelection(pos, pos);
                simplemde.codemirror.replaceSelection(text);
            });

            // viewer mode
            if (this.viewer) {
                this.content = this.value;

                setTimeout(() => {
                    this.$refs.editor.simplemde.togglePreview();
                }, 100)

                this.$refs.editor.$el.classList.add('preview-mode')
            }
        },

        components: {
            VueSimplemde
        }
    }
</script>

<style lang="scss">
    @import '~simplemde-theme-base/dist/simplemde-theme-base.min.css';

    .preview-mode {
        .CodeMirror-scroll {
            display: none;
        }

        .editor-toolbar {
            display: none;
        }

        .CodeMirror, .editor-preview {
            padding: 0;
            display: block;
            position: relative;
            background: transparent;
            border: none;
            overflow: visible;
            margin-bottom: 2rem;

            p {
                font-size: large;
                line-height: 1.5;
                color: #636b6f;
            }

            a {
                margin-top: 5px;
                margin-bottom: 5px;
                display: inline-block;
                color: white;
                border: thin solid var(--color-brand-primary);
                background-color: var(--color-brand-primary);
                border-radius: 0.25rem;
                padding: 0.5rem 1rem 0.5rem 1rem;
                white-space: nowrap;
                cursor: pointer;
                text-decoration: none !important;
                &:hover:not([disabled]) {
                    text-decoration: none;
                    color: white;
                    filter: grayscale(20%);
                }
            }

            th:empty {
                display: none;
            }

            td {
                background: none;
            }

            h1, h2, h3, h4, h5, h6 {
                margin: 1rem 0;
            }
        }
    }
</style>